import { MESApiService } from "@dexteel/mesf-core";

export const getSystemActivityStatistics = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[MMS].[GetSystemActivityStatistics]",
		[],
	);

	return resp;
};
